import styled from '@emotion/styled';
import { FormControl, FormHelperText, Input } from '@material-ui/core';
import { Error as MuiErrorIcon } from '@material-ui/icons';
import { createElement, FC } from 'react';
import { FormattedMessage } from 'react-intl';

import { ProjectDetailsFragment, ProjectDetailsWithoutPricingDataFragment } from '../../../../generated/graphql';
import { SPACING_UNIT } from '../../../constant/spacing';
import { isProjectInstanceOfProjectDetailsFragment } from '../../../page/ProjectEditingPage/hooks/useUpdateProject';
import { EditingProjectStateErrors } from '../../../types/EditingProjectState';
import { Language } from '../../../types/Language';

type Props = {
  title: string;
  language: Language;
  onChangeTitle: (title: string) => void;
  errors: EditingProjectStateErrors;
  projectType?: ProjectDetailsFragment['projectType'] | ProjectDetailsWithoutPricingDataFragment['projectType'] | null;
};

const ProjectTitleEditor: FC<Props> = ({ title, projectType, language, onChangeTitle, errors }) => {
  const validationErrorTexts = errors.titleErrors.map((err) => (
    <FormHelperText error key={err.message}>
      <StyledErrorIcon />

      <FormattedMessage id={`project_title_editor.validation.${err.message}`} />
    </FormHelperText>
  ));

  return (
    <StyledFormControl fullWidth required error={errors.titleErrors.length > 0}>
      <Input
        fullWidth
        defaultValue={title === 'Untitled Project' ? '' : title}
        placeholder={
          projectType &&
          isProjectInstanceOfProjectDetailsFragment(projectType) &&
          (projectType as ProjectDetailsFragment['projectType']).key === 'project_type_jp_for_google_smb' &&
          language === 'ja-JP'
            ? '入力例）【企業名】案件タイトル'
            : ''
        }
        onChange={(e) => onChangeTitle(e.currentTarget.value)}
      />
      {validationErrorTexts}
    </StyledFormControl>
  );
};

const StyledFormControl = styled(FormControl)`
  padding-bottom: ${SPACING_UNIT / 2}px;
`;

const StyledErrorIcon = styled(MuiErrorIcon)`
  width: 14px;
  height: 14px;
  margin-right: ${SPACING_UNIT / 2}px;
  vertical-align: bottom;
`;

export default ProjectTitleEditor;
